/**
 * @author Kelnik
 *
 * SliderPerson - Слайдер персонала
 */

import 'slick-carousel/slick/slick.css';
import 'slick-carousel';
import SliderArrows from 'components/slider-arrows';

class SliderPerson {
    constructor(options) {
        this.options = options;
        this.container = options.container;
        this.trackSelector = '.j-slider-person-track';
        this.prevSelector = '.j-slider-person-prev';
        this.nextSelector = '.j-slider-person-next';
        this.arrowsSelector = '.j-slider-arrows';

        this.slider = null;
        this.arrow = null;
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initSlider();
        this._initArrows();
        this._bindEvents();
    }

    _initElements() {
        this.track = this.container.querySelector(this.trackSelector);
        this.prev = this.container.querySelector(this.prevSelector);
        this.next = this.container.querySelector(this.nextSelector);
        this.arrowsEl = this.container.querySelector(this.arrowsSelector);
    }

    _initSlider() {
        this.slider = $(this.track).slick({
            infinite      : true,
            slidesToShow  : 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            prevArrow     : this.prev,
            nextArrow     : this.next
        });

        this.slider.on('swipe', () => {
            this.arrow.stopTimer();
        });
    }

    _initArrows() {
        if (!this.slider) {
            return;
        }

        this.arrow = new SliderArrows({
            container: this.arrowsEl,
            timeout  : () => {
                this.slider.slick('slickNext');
            }
        });

        this.arrow.init();
    }

    _bindEvents() {
        window.addEventListener('scroll', this._setAutoPlay.bind(this));
    }

    _setAutoPlay() {
        /* eslint-disable */
        const rect = this.container.getBoundingClientRect();

        // if (rect.top < 0) {
        // this.arrow.stopTimer();
        // } else {
        // this.arrow.startTimer();
        // }
    }
}

export default SliderPerson;
